import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Container from "@material-ui/core/Container";
import Layout from "../../components/common/hoc/Layout";
import { makeStyles } from "@material-ui/core/styles";
import CustomSpinner from "../../components/common/Spinner/CustomSpinner";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";
import Box from "@material-ui/core/Box";
import TablePagination from "@material-ui/core/TablePagination";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import EnhancedTableHead from "../../components/common/table/EnhancedTableHead";
import Add from "./components/add";
import Edit from "./components/edit";
import NotFound from "../../components/common/notFound/NotFound";
import RecordChangeButtons from "../../components/common/recordChangeButtons/RecordChangeButtons";
import { useTranslation } from "react-i18next";
import { listClients } from "../../store/client";
import { addClient } from "../../store/client";
import { updateClient } from "../../store/client";
import { deleteClient } from "../../store/client";
import { showCustomConfirmationDialog } from "../../store/customConfirmationDialogReducer";
import { getComparator, stableSort } from "../../utils/tableFilter";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    marginTop: "1rem",
    minWidth: 750,
  },
  rowEnable: {
    outlineColor: theme.palette.secondary.main,
    outlineWidth: "2px",
    outlineStyle: "solid",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
  },
  buttonAdd: {
    marginLeft: theme.spacing(1),
  },
}));

const RegisterClient = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const clientReducer = useSelector((state) => state.clientReducer);
  const { loading, error, client } = clientReducer;
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [rowEnable, setRowEnable] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [email, setEmail] = useState("");
  const [isEnabledFormAddClient, setIsEnabledFormAddAdmin] = useState(false);
  const [isEnabledFormEditClient, setIsEnabledFormEditAdmin] = useState(false);
  const [currentClient, setCurrentAdmin] = useState();
  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: t("client.headCells.name"),
    },
    {
      id: "cnpj",
      numeric: false,
      disablePadding: false,
      label: t("client.headCells.cnpj"),
    },
    {
      id: "fantasyName",
      numeric: false,
      disablePadding: false,
      label: t("client.headCells.fantasyName"),
    },
    {
      id: "contractorName",
      numeric: false,
      disablePadding: false,
      label: t("client.headCells.contractorName"),
    },
    {
      id: "cnpjMatriz",
      numeric: false,
      disablePadding: false,
      label: t("client.headCells.cnpjMatriz"),
    },
    {
      id: "contractType",
      numeric: false,
      disablePadding: false,
      label: t("client.headCells.contractType"),
    },
    {
      id: "expireContract",
      numeric: false,
      disablePadding: false,
      label: t("client.headCells.expireContract"),
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: t("client.headCells.email"),
    },
  ];
  const isSelected = (name) => selected.indexOf(name) !== -1;
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, client.length - page * rowsPerPage);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = client.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const toggleFormAdmin = () => {
    setIsEnabledFormAddAdmin((prev) => !prev);
    setIsEnabledFormEditAdmin(false);
  };

  const toggleFormEdit = (isEnable) => {
    setIsEnabledFormAddAdmin(false);
    setIsEnabledFormEditAdmin(isEnable);
  };

  const focusOnlastItemAdded = () => {
    setRowEnable(true);
    setTimeout(function () {
      setRowEnable(false);
    }, 3000);
  };

  const addHandler = async (formValues) => {
    setEmail(formValues.email);

    await dispatch(
      addClient(
        formValues.name,
        formValues.email,
        formValues.cnpj,
        formValues.fantasyName,
        formValues.expireContract,
        formValues.contractType
      )
    );
    await dispatch(listClients());
    setSelected([]);
    focusOnlastItemAdded();
  };

  const deleteHandler = (client) => {
    const configDialog = {
      title: t("client.deleteDialog.title"),
      message: `${t("client.deleteDialog.firstMessage")} "${client.name}", ${t(
        "client.deleteDialog.secondMessage"
      )}`,
      onSubmit: async function () {
        await dispatch(deleteClient(client))
          .then(async (result) => {
            dispatch({ type: "CUSTOM_CONFIRMATION_DIALOG_CLOSED" });
            await dispatch(listClients());
            setSelected([]);
          })
          .catch((err) => {
            dispatch({
              type: "ADMIN_DELETE_FAIL",
              payload: error,
            });
          });
      },

      close: async function () {
        await dispatch({ type: "CUSTOM_CONFIRMATION_DIALOG_CLOSED" });
      },
      buttons: {
        cancel: t("client.deleteDialog.buttons.cancel"),
        confirm: t("client.deleteDialog.buttons.confirm"),
      },
    };

    dispatch(
      showCustomConfirmationDialog({
        ...configDialog,
      })
    );
  };

  const editHandler = (client) => {
    toggleFormEdit(false);
    setCurrentAdmin(client);
    const configDialog = {
      title: t("client.editDialog.title"),
      message: `${t("client.editDialog.firstMessage")} "${client.name}", ${t(
        "client.editDialog.secondMessage"
      )}`,
      onSubmit: function () {
        toggleFormEdit(true);
      },
      close: async function () {
        await dispatch({ type: "CUSTOM_CONFIRMATION_DIALOG_CLOSED" });
      },
      buttons: {
        cancel: t("client.editDialog.buttons.cancel"),
        confirm: t("client.editDialog.buttons.confirm"),
      },
    };
    dispatch(
      showCustomConfirmationDialog({
        ...configDialog,
      })
    );
  };

  const updateHandler = async (formValues) => {
    setEmail(formValues.email);
    await dispatch(
      updateClient(
        currentClient?.id,
        formValues.name,
        formValues.email,
        formValues.cnpj,
        formValues.fantasyName,
        formValues.expireContract,
        formValues.contractType
      )
    );
    await dispatch(listClients());
    setSelected([]);
    focusOnlastItemAdded();
  };

  const formConfigI18n = {
    singleDeleteButton: t("client.singleDeleteButton"),
    singleDeleteMultipleButton: t("client.singleDeleteMultipleButton"),
    addForm: {
      title: t("client.addForm.title"),
      cancelButton: t("client.addForm.cancelButton"),
      confirmButton: t("client.addForm.confirmButton"),
      name: {
        requiredErrorMsg: t("client.addForm.name.requiredErrorMsg"),
        label: t("client.addForm.name.label"),
        placeholder: t("client.addForm.name.placeholder"),
      },
      email: {
        requiredErrorMsg: t("client.addForm.email.requiredErrorMsg"),
        label: t("client.addForm.email.label"),
        placeholder: t("client.addForm.email.placeholder"),
      },
      fantasyName: {
        requiredErrorMsg: t("client.addForm.fantasyName.requiredErrorMsg"),
        label: t("client.addForm.fantasyName.label"),
        placeholder: t("client.addForm.fantasyName.placeholder"),
      },
      cnpj: {
        requiredErrorMsg: t("client.addForm.cnpj.requiredErrorMsg"),
        label: t("client.editForm.cnpj.label"),
        placeholder: t("client.editForm.cnpj.placeholder"),
      },
      cnpjMatriz: {
        requiredErrorMsg: t("client.addForm.cnpjMatriz.requiredErrorMsg"),
        label: t("client.editForm.cnpjMatriz.label"),
        placeholder: t("client.editForm.cnpjMatriz.placeholder"),
      },
      expireContract: {
        requiredErrorMsg: t("client.addForm.expireContract.requiredErrorMsg"),
        label: t("client.addForm.expireContract.label"),
        placeholder: t("client.addForm.expireContract.placeholder"),
      },
      contractType: {
        requiredErrorMsg: t("client.addForm.contractType.requiredErrorMsg"),
        label: t("client.addForm.contractType.label"),
        placeholder: t("client.addForm.contractType.placeholder"),
      },
    },
    editForm: {
      title: t("client.editForm.title"),
      cancelButton: t("client.editForm.cancelButton"),
      confirmButton: t("client.editForm.confirmButton"),
      name: {
        requiredErrorMsg: t("client.editForm.name.requiredErrorMsg"),
        label: t("client.editForm.name.label"),
        placeholder: t("client.editForm.name.placeholder"),
      },
      email: {
        requiredErrorMsg: t("client.editForm.email.requiredErrorMsg"),
        label: t("client.editForm.email.label"),
        placeholder: t("client.editForm.email.placeholder"),
      },
      fantasyName: {
        requiredErrorMsg: t("client.editForm.fantasyName.requiredErrorMsg"),
        label: t("client.editForm.fantasyName.label"),
        placeholder: t("client.editForm.fantasyName.placeholder"),
      },
      cnpj: {
        requiredErrorMsg: t("client.editForm.cnpj.requiredErrorMsg"),
        label: t("client.editForm.cnpj.label"),
        placeholder: t("client.editForm.cnpj.placeholder"),
      },
      cnpjMatriz: {
        requiredErrorMsg: t("client.editForm.cnpjMatriz.requiredErrorMsg"),
        label: t("client.editForm.cnpjMatriz.label"),
        placeholder: t("client.editForm.cnpjMatriz.placeholder"),
      },
      expireContract: {
        requiredErrorMsg: t("client.editForm.expireContract.requiredErrorMsg"),
        label: t("client.editForm.expireContract.label"),
        placeholder: t("client.editForm.expireContract.placeholder"),
      },
      contractType: {
        requiredErrorMsg: t("client.editForm.contractType.requiredErrorMsg"),
        label: t("client.editForm.contractType.label"),
        placeholder: t("client.editForm.contractType.placeholder"),
      },
    },
  };

  useEffect(() => {
    dispatch(listClients());
  }, [dispatch]);

  return (
    <Layout title={t("client.title")}>
      <Container disableGutters maxWidth={false}>
        <Box
          component="span"
          display={
            isEnabledFormAddClient || isEnabledFormEditClient ? "none" : "block"
          }
        >
          <Grid item xs={12} sm={12} lg={12}>
            <div className={classes.buttons}>
              <Button
                variant="contained"
                color="primary"
                disabled={loading}
                onClick={() => setIsEnabledFormAddAdmin((prev) => !prev)}
              >
                {t("client.addButton")}
              </Button>
            </div>
          </Grid>
        </Box>

        <Add
          translateValidation={formConfigI18n.addForm}
          isEnabledFormAddClient={!isEnabledFormAddClient}
          loading={loading}
          addHandler={addHandler}
          show={toggleFormAdmin}
        />

        <Edit
          translateValidation={formConfigI18n.editForm}
          isEnabledFormEditClient={!isEnabledFormEditClient}
          loading={loading}
          editHandler={updateHandler}
          show={toggleFormEdit}
          currentClient={currentClient}
        />

        <>
          {loading ? (
            <CustomSpinner />
          ) : error ? (
            <NotFound
              title="Oops!"
              message="Ocorreu um erro, tente recarregar a página"
              image="/images/notfound.png"
              redirect="/app/content"
            />
          ) : (
            <div>
              <TableContainer>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  aria-label="enhanced table"
                >
                  <EnhancedTableHead
                    headCells={headCells}
                    classes={classes}
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={client.length}
                  />
                  <TableBody>
                    {stableSort(client, getComparator(order, orderBy))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row);
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={0}
                            key={row.id}
                            selected={isItemSelected}
                            className={
                              row.email === email && rowEnable
                                ? classes.rowEnable
                                : ""
                            }
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                onClick={(event) => handleClick(event, row)}
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                              <IconButton
                                aria-label="edit"
                                onClick={(event) => editHandler(row)}
                              >
                                <EditIcon color="secondary" />
                              </IconButton>
                            </TableCell>
                            <TableCell padding="none">{row.name}</TableCell>
                            <TableCell align="left">{row.cnpjClient}</TableCell>
                            <TableCell align="left">
                              {row.nameFantasyClient}
                            </TableCell>
                            <TableCell align="left">
                              {row.contractorName}
                            </TableCell>
                            <TableCell align="left">
                              {row.cnpjContractor}
                            </TableCell>
                            <TableCell align="left">
                              {row.contractType}
                            </TableCell>
                            <TableCell align="left">
                              {row.dateContractValidity}
                            </TableCell>
                            <TableCell align="left">{row.email}</TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={headCells.length + 1} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <Box display="flex" p={1}>
                <Box p={1} flexGrow={1}>
                  <TablePagination
                    rowsPerPageOptions={[10, 25]}
                    component="div"
                    count={client.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </Box>
                <Box p={1} flexGrow={1}>
                  <RecordChangeButtons
                    singleDeleteButton={formConfigI18n.singleDeleteButton}
                    singleDeleteMultipleButton={
                      formConfigI18n.singleDeleteMultipleButton
                    }
                    itensSelected={selected}
                    handlerSingle={deleteHandler}
                    icon={<DeleteIcon />}
                  />
                </Box>
              </Box>
            </div>
          )}
        </>
      </Container>
    </Layout>
  );
};

export { RegisterClient };
